<template>
    <app-modal-share
        :window-title="group.name"
        :twitter-share="false"
        :classroom-share="true"
        :share-url="group.shortCode"
        @close="$emit('close')"
    >
        <template #header-left-button>
            <button
                v-t="'Buttons.edit'"
                class="button is-flat is-primary is-inverted"
                @click="$emit('edit')"
            ></button>
        </template>
        <template #content>
            <div class="has-text-centered">
                <p class="title is-3 has-text-weight-bold">
                    {{ group.name }}
                </p>
                <p class="title is-3 has-text-weight-bold">
                    <span class="icon"> <i class="mdi mdi-key-variant" /> </span
                    ><span class="pl-3">{{ group.shortCode }}</span>
                </p>
            </div>
        </template>
    </app-modal-share>
</template>

<script>
import AppModalShare from '@/components/AppModalShare';
export default {
    components: {
        AppModalShare,
    },
    props: {
        group: {
            type: Object,
            default() {
                return {};
            },
        },
    },
};
</script>

<style></style>
